import { Controller } from "@hotwired/stimulus";

// cash-order-amount: drives the "Withdraw to ATM" amount screen — the quick-amount
// pills ($20 / $50 / $100 / Max) and their selected state. Coexists with the shared
// `money` (format/autosize) and `max-amount` (min/max cap) controllers on the input.
export default class CashOrderAmountController extends Controller {
  static targets = ["amount", "pill"];

  static values = {
    max: Number,
  };

  connect() {
    this._onInput = () => this.syncPills();
    if (this.hasAmountTarget) {
      this.amountTarget.addEventListener("input", this._onInput);
    }
    this.syncPills();
  }

  disconnect() {
    if (this.hasAmountTarget && this._onInput) {
      this.amountTarget.removeEventListener("input", this._onInput);
    }
  }

  // setPreset fills the input from a pill's data-amount.
  setPreset(event) {
    event.preventDefault();
    const amount = Number.parseFloat(event.currentTarget.dataset.amount);
    if (!Number.isNaN(amount)) this.setAmount(amount);
  }

  // setMax fills the input with the maximum collectable amount.
  setMax(event) {
    event.preventDefault();
    this.setAmount(this.hasMaxValue ? this.maxValue : 0);
  }

  setAmount(amount) {
    if (!this.hasAmountTarget) return;
    const capped = this.hasMaxValue ? Math.min(amount, this.maxValue) : amount;
    this.amountTarget.value = capped.toFixed(2);
    // Let money/max-amount controllers react (autosize, cap, validation).
    this.amountTarget.dispatchEvent(new Event("input", { bubbles: true }));
    this.syncPills();
  }

  // syncPills toggles the selected style on the pill matching the current amount.
  syncPills() {
    const amt = this.hasAmountTarget ? Number.parseFloat(this.amountTarget.value) || 0 : 0;
    this.pillTargets.forEach((pill) => {
      const isMax = pill.dataset.pillMax !== undefined;
      const val = isMax ? (this.hasMaxValue ? this.maxValue : Number.NaN) : Number.parseFloat(pill.dataset.amount);
      const active = !Number.isNaN(val) && Math.abs(val - amt) < 0.005;
      pill.classList.toggle("cash-pill-active", active);
    });
  }
}
